import { usePenguinFlag } from "@/hooks/usePenguinFlag";

const ART = {
  "great-job": { src: "/brand/penguin-great-job.png", alt: "ZRo Pe penguin celebrating a successful transaction" },
  "not-found": { src: "/brand/penguin-not-found.png", alt: "ZRo Pe penguin showing that the requested page was not found" },
  "service-unavailable": { src: "/brand/penguin-service-unavailable.png", alt: "ZRo Pe penguin indicating that the service is temporarily unavailable" },
  "maintenance": { src: "/brand/penguin-maintenance.png", alt: "ZRo Pe penguin indicating that the service is under maintenance" },
  "network": { src: "/brand/penguin-network-issue.png", alt: "ZRo Pe penguin indicating a network connection problem" },
};

// Responsive contextual illustration. `size="page"` for full-page states, `size="inline"` for
// compact success placement. Renders nothing (image-wise) when the admin feature flag is off —
// the surrounding text/CTAs must always carry the message on their own.
export function PenguinIllustration({ variant, size = "page", className = "", testid }) {
  const enabled = usePenguinFlag();
  const art = ART[variant];
  if (!enabled || !art) return null;
  const width = size === "inline"
    ? "w-[clamp(150px,40vw,240px)]"
    : "w-[clamp(180px,55vw,420px)]";
  return (
    <img
      src={art.src}
      alt={art.alt}
      loading="lazy"
      decoding="async"
      data-testid={testid || `penguin-${variant}`}
      className={`mx-auto h-auto ${width} max-h-[46vh] object-contain ${className}`}
    />
  );
}

export default PenguinIllustration;
